import React from 'react'
import classes from './tableHeadings.module.css'
const Headings = ({children}) =>{
    return(
        <th className={classes.headings}>
            {children}
        </th>
    )
}
export default Headings;